var map = {
	"./0/Kambi/Rewards.resource.js": [
		90075,
		[
			1002
		]
	],
	"./0/Poker/Rewards.resource.js": [
		15346,
		[
			6197
		]
	],
	"./0/Spectate/Rewards.resource.js": [
		98930,
		[
			9619
		]
	],
	"./1/Kambi/Rewards.resource.js": [
		34478,
		[
			6591
		]
	],
	"./1/Poker/Rewards.resource.js": [
		4339,
		[
			4534
		]
	],
	"./1/Spectate/Rewards.resource.js": [
		11505,
		[
			7454
		]
	],
	"./31/Kambi/Rewards.resource.js": [
		49267,
		[
			4714
		]
	],
	"./31/Poker/Rewards.resource.js": [
		43418,
		[
			9523
		]
	],
	"./31/Spectate/Rewards.resource.js": [
		16106,
		[
			7593
		]
	],
	"./58/Spectate/Rewards.resource.js": [
		93487,
		[
			3410
		]
	],
	"./75/Kambi/Rewards.resource.js": [
		85547,
		[
			2546
		]
	],
	"./75/Spectate/Rewards.resource.js": [
		48514,
		[
			9625
		]
	],
	"./76/Kambi/Rewards.resource.js": [
		33852,
		[
			6105
		]
	],
	"./76/Spectate/Rewards.resource.js": [
		94731,
		[
			2978
		]
	],
	"./8/Poker/Rewards.resource.js": [
		80666,
		[
			5021
		]
	],
	"./8/Spectate/Rewards.resource.js": [
		50858,
		[
			4603
		]
	],
	"./81/Kambi/Rewards.resource.js": [
		42214,
		[
			3359
		]
	],
	"./81/Spectate/Rewards.resource.js": [
		20233,
		[
			6384
		]
	],
	"./84/Kambi/Rewards.resource.js": [
		99831,
		[
			38
		]
	],
	"./84/Spectate/Rewards.resource.js": [
		94670,
		[
			5889
		]
	],
	"./86/Spectate/Rewards.resource.js": [
		95640,
		[
			9231
		]
	],
	"./87/Spectate/Rewards.resource.js": [
		88231,
		[
			7962
		]
	],
	"./88/Spectate/Rewards.resource.js": [
		82066,
		[
			9381
		]
	],
	"./89/Spectate/Rewards.resource.js": [
		59473,
		[
			4056
		]
	],
	"./90/Spectate/Rewards.resource.js": [
		11011,
		[
			5254
		]
	],
	"./91/Spectate/Rewards.resource.js": [
		70804,
		[
			3019
		]
	],
	"./92/Spectate/Rewards.resource.js": [
		76825,
		[
			9376
		]
	],
	"./94/Spectate/Rewards.resource.js": [
		61719,
		[
			9594
		]
	],
	"./95/Spectate/Rewards.resource.js": [
		45448,
		[
			7231
		]
	],
	"./96/Poker/Rewards.resource.js": [
		50263,
		[
			2284
		]
	],
	"./96/Spectate/Rewards.resource.js": [
		58637,
		[
			8548
		]
	],
	"./default/Kambi/Rewards.resource.js": [
		37048,
		[
			9779
		]
	],
	"./default/Spectate/Rewards.resource.js": [
		27319,
		[
			9606
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 60076;
module.exports = webpackAsyncContext;